import PropTypes from "prop-types";
import { DropLink, DropTargetContainer, DropText } from "./StyledComponents";
import { FolderIcon } from "../../assets/icons";

const DropTarget = ({ name }) => {
  return (
    <DropTargetContainer>
      <DropText variant="body2">Drop file to:</DropText>
      <DropLink underline="hover">
        <FolderIcon /> {name}
      </DropLink>
    </DropTargetContainer>
  );
};

DropTarget.propTypes = {
  name: PropTypes.string.isRequired,
};

export default DropTarget;
